/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetSalesInvoicePaymentDto
 */
export interface GetSalesInvoicePaymentDto {
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoicePaymentDto
     */
    pokId: string;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoicePaymentDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoicePaymentDto
     */
    invoiceNumber: string;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoicePaymentDto
     */
    amount: string;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoicePaymentDto
     */
    paymentType: string;
    /**
     * 
     * @type {Date}
     * @memberof GetSalesInvoicePaymentDto
     */
    paymentDate: Date | null;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoicePaymentDto
     */
    correctionInvoiceNumber: string | null;
    /**
     * 
     * @type {Date}
     * @memberof GetSalesInvoicePaymentDto
     */
    correctionIssueDate: Date | null;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoicePaymentDto
     */
    currentInvoiceBalance: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetSalesInvoicePaymentDto
     */
    companyId: number;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoicePaymentDto
     */
    companyName: string | null;
}

/**
 * Check if a given object implements the GetSalesInvoicePaymentDto interface.
 */
export function instanceOfGetSalesInvoicePaymentDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "pokId" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "invoiceNumber" in value;
    isInstance = isInstance && "amount" in value;
    isInstance = isInstance && "paymentType" in value;
    isInstance = isInstance && "paymentDate" in value;
    isInstance = isInstance && "correctionInvoiceNumber" in value;
    isInstance = isInstance && "correctionIssueDate" in value;
    isInstance = isInstance && "currentInvoiceBalance" in value;
    isInstance = isInstance && "companyId" in value;
    isInstance = isInstance && "companyName" in value;

    return isInstance;
}

export function GetSalesInvoicePaymentDtoFromJSON(json: any): GetSalesInvoicePaymentDto {
    return GetSalesInvoicePaymentDtoFromJSONTyped(json, false);
}

export function GetSalesInvoicePaymentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSalesInvoicePaymentDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pokId': json['pokId'],
        'id': json['id'],
        'invoiceNumber': json['invoiceNumber'],
        'amount': json['amount'],
        'paymentType': json['paymentType'],
        'paymentDate': (json['paymentDate'] === null ? null : new Date(json['paymentDate'])),
        'correctionInvoiceNumber': json['correctionInvoiceNumber'],
        'correctionIssueDate': (json['correctionIssueDate'] === null ? null : new Date(json['correctionIssueDate'])),
        'currentInvoiceBalance': json['currentInvoiceBalance'],
        'companyId': json['companyId'],
        'companyName': json['companyName'],
    };
}

export function GetSalesInvoicePaymentDtoToJSON(value?: GetSalesInvoicePaymentDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pokId': value.pokId,
        'id': value.id,
        'invoiceNumber': value.invoiceNumber,
        'amount': value.amount,
        'paymentType': value.paymentType,
        'paymentDate': (value.paymentDate === null ? null : value.paymentDate.toISOString()),
        'correctionInvoiceNumber': value.correctionInvoiceNumber,
        'correctionIssueDate': (value.correctionIssueDate === null ? null : value.correctionIssueDate.toISOString()),
        'currentInvoiceBalance': value.currentInvoiceBalance,
        'companyId': value.companyId,
        'companyName': value.companyName,
    };
}

